export default __webpack_public_path__ + "static/media/start-your-next-adventure.c77d958f.png";